<div class="container-table">
  <mat-table
    #table
    class="table table-p1 borderless align-middle"
    matSortDisableClear
    [dataSource]="dataSource"
    matSort
  >
    <!-- Checkbox Column -->
    <ng-container matColumnDef="select">
      <mat-header-cell
        *matHeaderCellDef
        [style.flex]="'0 0 ' + getColumnWidth('select')"
      >
        <mat-checkbox
          (change)="$event ? toggleAll() : null"
          [checked]="selection.hasValue() && isAllSelected()"
          [indeterminate]="selection.hasValue() && !isAllSelected()"
        >
        </mat-checkbox>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row"
        [style.flex]="'0 0 ' + getColumnWidth('select')"
      >
        <mat-checkbox
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
        >
        </mat-checkbox>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="id">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('id')"
      >
        <p class="label-desktop">Ordem</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('id')"
      >
        <span class="mobile-label">Ordem:</span>
        <p
          class="tappable label-desktop order-id"
          (click)="goOrderDetail(row?.id)"
        >
          {{ row?.id }}
        </p>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="createdDate">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('createdDate')"
      >
        <p class="label-desktop">Data de criação</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('createdDate')"
      >
        <span class="mobile-label">Data de criação:</span>

        <span class="label-desktop label-data">
          {{ row?.createdDate | date: "dd/MM/yyyy" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="paymentDate">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('paymentDate')"
      >
        <p class="label-desktop">Pagamento no exterior</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('paymentDate')"
      >
        <span class="mobile-label">Pagamento no exterior:</span>

        <span class="label-desktop label-data">
          {{ row?.conciliations[0]?.paymentDate | date: "dd/MM/yyyy" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="companyName">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('companyName')"
      >
        <p class="label-desktop">Nome do cliente</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('companyName')"
      >
        <span class="mobile-label">Nome do cliente:</span>
        <span *ngIf="row?.tipoPessoa == 'PJ'" class="label-desktop label-data">
          {{ row?.corporateAccount?.companyName }}
        </span>
        <span *ngIf="row?.tipoPessoa == 'PF'" class="label-desktop label-data">
          {{ row?.individualAccount?.name }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="clientInfo">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('clientInfo')"
      >
        <p class="label-desktop">Cliente</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('clientInfo')"
      >
        <span class="mobile-label">Cliente:</span>

        <span class="label-desktop label-data label-elipsis">
          <span
            *ngIf="row?.tipoPessoa == 'PJ'"
            [title]="row?.corporateAccount?.companyName"
            class="label-desktop"
          >
            {{ row?.corporateAccount?.companyName }}
          </span>
          <span
            *ngIf="row?.tipoPessoa == 'PF'"
            [title]="row?.individualAccount?.name"
            class="label-desktop"
          >
            {{ row?.individualAccount?.name }}
          </span>
          <br />
          <span *ngIf="row?.tipoPessoa == 'PJ'" class="label-desktop-bold">
            CNPJ:
          </span>
          <span *ngIf="row?.tipoPessoa == 'PF'" class="label-desktop-bold">
            CPF:
          </span>
          <span
            *ngIf="row?.tipoPessoa == 'PJ'"
            [title]="row?.corporateAccount?.cnpj"
            class="label-desktop"
            >{{
              row?.corporateAccount?.cnpj | mask: "AA.AAA.AAA/AAAA-00"
            }}</span
          >

          <span
            *ngIf="row?.tipoPessoa == 'PF'"
            [title]="row?.individualAccount?.cpf"
            class="label-desktop label-data"
          >
            {{ row?.individualAccount?.cpf | mask: "000.000.000-00" }}
          </span>
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="cnpj">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('cnpj')"
      >
        <p class="label-desktop">Doc. do cliente</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('cnpj')"
      >
        <span class="mobile-label">Doc. do cliente:</span>

        <span *ngIf="row?.tipoPessoa == 'PJ'" class="label-desktop label-data">
          {{ row?.corporateAccount?.cnpj | mask: "AA.AAA.AAA/AAAA-00" }}
        </span>

        <span *ngIf="row?.tipoPessoa == 'PF'" class="label-desktop label-data">
          {{ row?.individualAccount?.cpf | mask: "000.000.000-00" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="settlementFlowTreasury">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('settlementFlowTreasury')"
      >
        <p class="label-desktop">Fluxo</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('settlementFlowTreasury')"
      >
        <span class="mobile-label">Fluxo:</span>

        <span
          *ngIf="row?.settlementFlowTreasury == 'D0'"
          class="label-desktop label-data"
          title="Hoje (D0)"
        >
          (D0)</span
        >

        <span
          *ngIf="row?.settlementFlowTreasury == 'D+1'"
          class="label-desktop label-data"
          title="Amanhã (D1)"
          >(D1)</span
        >

        <span
          *ngIf="row?.settlementFlowTreasury == 'D+2'"
          class="label-desktop label-data"
          title="Depois de amanhã (D2)"
          >(D2)</span
        >

        <span
          *ngIf="row?.settlementFlowTreasury == 'Termo D0'"
          class="label-desktop label-data"
          title="Termo D+0"
          >Termo D+0</span
        >

        <span
          *ngIf="row?.settlementFlowTreasury == 'Termo D1'"
          class="label-desktop label-data"
          title="Termo D+1"
          >Termo D+1</span
        >

        <span
          *ngIf="row?.settlementFlowTreasury == 'Termo D2'"
          class="label-desktop label-data"
          title="Termo D+2"
          >Termo D+2</span
        >
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="reasonRefusalPayment">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('reasonRefusalPayment')"
      >
        <p class="label-desktop">Tipo de pendência</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('reasonRefusalPayment')"
      >
        <span class="mobile-label">Tipo de pendência:</span>

        <span *ngIf="row?.reasonRefusalPayment" class="size-row label-data">
          {{ row?.reasonRefusalPayment }}
        </span>

        <span
          *ngIf="row?.statusFlow == 'PENDING_PAYMENT_INFORMATION'"
          class="size-row label-data"
          title="Pendente informações de pagamento"
        >
          Pendente informações de pagamento
        </span>

        <span
          *ngIf="row?.statusFlow == 'AVAILABLE_QUOTATION'"
          class="size-row label-data"
          title="Aguardando cotação"
        >
          Aguardando cotação
        </span>

        <span
          *ngIf="
            row?.statusFlow == 'IDENTIFIED_PAYMENT_ABROAD' ||
            row?.statusFlow == 'PENDING_ORDER_INFORMATION'
          "
          class="label-desktop label-data"
          title="Pendente informações"
        >
          Pendente informações
        </span>

        <span
          *ngIf="row?.statusFlow == 'PENDING_INVOICE_ATTACHMENT'"
          class="size-row label-data"
          title="Invoice pendente"
          >Invoice pendente</span
        >
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="amount">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('amount')"
      >
        <p *ngIf="rType == '0'" class="label-desktop">Valor esperado</p>
        <p *ngIf="rType == '1'" class="label-desktop">Valor</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('amount')"
      >
        <span *ngIf="rType == '0'" class="mobile-label">Valor esperado:</span>
        <span *ngIf="rType == '1'" class="mobile-label">Valor:</span>

        <div *ngIf="row?.currency?.description">
          <span class="label-desktop">{{ row?.currency?.description }} </span
          ><span class="label-desktop-amount">{{
            row?.amount | amountPipe
          }}</span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="amountMN">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('amountMN')"
      >
        <p class="label-desktop">Valor R$</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('amountMN')"
      >
        <span class="mobile-label">Valor R$:</span>

        <div class="label-desktop">
          {{ row?.quotations[0]?.amountMN | brl }}
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="tipoPessoa">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('tipoPessoa')"
      >
        <p class="label-desktop">Cadastro</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('tipoPessoa')"
      >
        <span class="mobile-label">Cadastro:</span>

        <span class="label-desktop label-data text-center">
          {{ row?.tipoPessoa }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="orderSource">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('orderSource')"
      >
        <p class="label-desktop">Origem</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('orderSource')"
      >
        <span class="mobile-label">Origem:</span>

        <div
          *ngIf="row?.orderSource === 'HOMEBROKER'"
          class="chip-platform chip-pink"
          title="Plataforma"
        >
          Plataforma
        </div>

        <div
          *ngIf="row?.orderSource === 'PARTNER'"
          class="chip-platform chip-blue"
          title="Parceiro"
        >
          Parceiro
        </div>

        <div
          *ngIf="row?.orderSource === 'ADMIN'"
          class="chip-platform chip-order-by-admin"
          title="Operação"
        >
          Operação
        </div>

        <div
          *ngIf="row?.orderSource === 'EXCHANGE'"
          class="chip-platform chip-exchange"
          title="Exchange"
        >
          Exchange
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="status">
      <mat-header-cell
        *matHeaderCellDef
        [style.flex]="'0 0 ' + getColumnWidth('status')"
      >
        <p class="label-desktop">Status</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('status')"
      >
        <span
          class="size-row label-data"
          [title]="row | orderStatus"
        >
          {{ row | orderStatus }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="accountStatus">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('accountStatus')"
      >
        <p class="label-desktop">Status</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('accountStatus')"
      >
        <span class="mobile-label">Status:</span>

        <div class="status-tag-container">
          <span
            *ngFor="let statusItem of row?.accountStatus"
            class="status-tag {{ getStatusClass(statusItem) }}"
          >
            {{ getStatusLabel(statusItem) }}
          </span>
        </div>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="agency">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('agency')"
      >
        <p class="label-desktop">Agência</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('agency')"
      >
        <span class="mobile-label">Agência:</span>
        <span class="label-desktop label-data">
          {{
            row?.corporateAccount?.businessPartner?.agencyNumber ||
              row?.individualAccount?.businessPartner?.agencyNumber
          }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="slipCode">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('slipCode')"
      >
        <p class="label-desktop">Nº do boleto</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('slipCode')"
      >
        <span class="mobile-label">Nº do boleto:</span>
        <span
          *ngIf="row?.slipCode"
          [title]="row?.slipCode"
          class="label-desktop label-data slip-code-container"
        >
          {{ row?.slipCode }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="sendOption">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('sendOption')"
      >
        <p class="label-desktop">Opção de envio</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('sendOption')"
      >
        <span class="mobile-label">Opção de envio:</span>
        <span class="label-desktop label-data">
          {{ row?.quotations[0]?.deliveryOption || "-" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="spread">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('spread')"
      >
        <p class="label-desktop">Spread</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('spread')"
      >
        <span class="mobile-label">Spread:</span>
        <span class="label-desktop label-data">
          {{ getCommercialRate(row) || "-" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="bankCurrencyTreasury">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('bankCurrencyTreasury')"
      >
        <p class="label-desktop">Origem da moeda</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('bankCurrencyTreasury')"
      >
        <span class="mobile-label">Origem da moeda:</span>
        <span class="label-desktop label-data">
          {{ row?.bankCurrencyTreasury || "-" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="levelingRateTreasury">
      <mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [style.flex]="'0 0 ' + getColumnWidth('levelingRateTreasury')"
      >
        <p class="label-desktop">Nivela</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('levelingRateTreasury')"
      >
        <span class="mobile-label">Nivela:</span>
        <span class="label-desktop label-data">
          {{ row?.levelingRateTreasury || "-" }}
        </span>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="action">
      <mat-header-cell
        *matHeaderCellDef
        [style.flex]="'0 0 ' + getColumnWidth('action')"
      >
        <p class="label-desktop">Ações</p>
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row; let i = index"
        [style.flex]="'0 0 ' + getColumnWidth('action')"
      >
        <span
          *ngIf="row?.statusFlow == 'IDENTIFYING_PAYMENT_ABROAD'"
          class="size-row label-data tappable"
          title="Confirmar pagamento da ordem no exterior"
          (click)="openConfirmPaymentExteriorModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/edit-inbound.svg"
        /></span>

        <span
          *ngIf="row?.statusFlow == 'PENDING_PAYMENT_INFORMATION'"
          class="size-row label-data"
          >-</span
        >
        <span
          *ngIf="row?.statusFlow == 'PROCESSING'"
          class="size-row label-data tappable"
          title="Analisar a ordem"
          (click)="openOrderReviewModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/review-order.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            !row?.confirmationSlip &&
            row?.remmitanceType == 'INBOUND'
          "
          class="size-row label-data tappable"
          title="Informações a tesouraria"
          (click)="openTreasuryInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/treasury-info.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            !row?.confirmationSlip &&
            currentTab === 'Ordens cotadas' &&
            row?.remmitanceType == 'OUTBOUND' &&
            !row?.confirmationTreasury
          "
          class="size-row label-data tappable"
          title="Informações a tesouraria"
          (click)="openTreasuryInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/treasury-info.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            !row?.confirmationSlip &&
            currentTab === 'Ordens cotadas' &&
            row?.remmitanceType == 'OUTBOUND' &&
            row?.confirmationTreasury
          "
          class="size-row label-data tappable"
          title="Editar informações"
          (click)="openTreasuryInfoModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/treasury-info-success.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            !row?.confirmationSlip &&
            currentTab === 'Boletagem' &&
            row?.remmitanceType == 'OUTBOUND'
          "
          class="size-row label-data tappable"
          title="Enviar para o Exchange"
          (click)="openExchangeInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/exchange-info.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            !row?.confirmationSlip &&
            row?.remmitanceType == 'INBOUND'
          "
          class="size-row label-data tappable"
          title="Enviar para o Exchange"
          (click)="openExchangeInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/exchange-info.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            row?.effected &&
            row?.remmitanceType == 'OUTBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar pagamento"
          (click)="openPaymentConfirmModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/confirm-reais.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            row?.effected &&
            row?.remmitanceType == 'OUTBOUND' &&
            !row?.orderSettlement?.exchangeContractFile
          "
          class="size-row label-data tappable"
          title="Enviar contrato"
          (click)="openSendContractModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/send-contract.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            row?.effected &&
            row?.remmitanceType == 'OUTBOUND' &&
            row?.orderSettlement?.exchangeContractFile
          "
          class="size-row label-data tappable"
          title="Reenviar contrato"
          (click)="openSendContractModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/send-contract-success.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            !row?.effected &&
            row?.remmitanceType == 'OUTBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar efetivação"
          (click)="openExecutionOrderModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/confirm-effectivate.svg"
        /></span>
        <span
          *ngIf="
            (row?.statusFlow == 'AVAILABLE_PAYMENT' ||
              row?.statusFlow == 'IDENTIFYING_PAYMENT') &&
            row?.confirmationTreasury &&
            row?.confirmationSlip &&
            row?.remmitanceType == 'INBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar pagamento em reais"
          (click)="openPaymentConfirmModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/confirm-payment-brasil.svg"
        /></span>
        <span
          *ngIf="
            row?.statusFlow == 'IDENTIFIED_PAYMENT' &&
            row?.remmitanceType == 'OUTBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar liquidação no exterior"
          (click)="openSettlementInfoModal(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/confirm-exterior.svg"
        /></span>

        <span
          *ngIf="
            row?.statusFlow == 'IDENTIFIED_PAYMENT' &&
            row?.remmitanceType == 'INBOUND'
          "
          class="size-row label-data tappable"
          title="Confirmar pagamento no Brasil"
          (click)="openSettlementInfoModal(row?.id)"
          ><img
            class="pr-2"
            src="assets/image/tooltips/confirm-payment-brasil.svg"
        /></span>

        <span
          *ngIf="
            row?.statusFlow == 'PAYMENT_REPROVED' ||
            row?.statusFlow == 'PENDING_INVOICE_ATTACHMENT'
          "
          class="size-row label-data tappable"
          title="Ver detalhes da ordem"
          (click)="goOrderDetail(row?.id)"
          ><img class="pr-2" src="assets/image/tooltips/view-details.svg"
        /></span>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row
      *matRowDef="let row; let i = index; columns: displayedColumns"
      [ngClass]="{ selected: selection.isSelected(row) }"
    >
    </mat-row>
  </mat-table>
</div>

<mat-paginator
  class="custom-paginator"
  [pageIndex]="pageNumber"
  [pageSize]="pageSize"
  [length]="totalElements"
  (page)="chanePageEvent($event)"
  [pageSizeOptions]="[5, 10, 25, 50]"
  showFirstLastButtons
></mat-paginator>
